import { takeLatest, call, put } from "redux-saga/effects";

import api from "Util/api";

// Actions
const types = {
    GET_NORMS_REQUESTED: "GET_NORMS_REQUESTED",
    GET_NORMS_SUCCEEDED: "GET_NORMS_SUCCEEDED",
    GET_NORMS_FAILED: "GET_NORMS_FAILED"
};

// Action Creators
export const actions = {
    get: callback => {
        return {
            type: types.GET_NORMS_REQUESTED,
            callback
        };
    }
};

// Default state
const defaultState = {
    data: [],
    error: "",
    loading: true
};

// Reducers
export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.GET_NORMS_REQUESTED:
            return {
                ...state,
                loading: true
            };
        case types.GET_NORMS_SUCCEEDED:
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        case types.GET_NORMS_FAILED:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        default:
            return state;
    }
}

// Sagas
export function* saga() {
    yield takeLatest(types.GET_NORMS_REQUESTED, startGetNormsWorker);
}

// Saga callback
function* startGetNormsWorker({ callback }) {
    try {
        const response = yield call(get);

        if (!response.ok) {
            throw response.data;
        }

        yield put({
            type: types.GET_NORMS_SUCCEEDED,
            payload: response.data
        });

        typeof callback == "function" && callback(response.data);
    } catch (e) {
        console.error({ e });
        yield put({ type: types.GET_NORMS_FAILED, error: e.error });
    }
}

// API call
function get() {
    return api.get(`/api/personality-test/norms`);
}
